import React, { Component } from 'react';
import { ScrollView, View, TouchableOpacity } from 'react-native';

import {
  sortBy as _sortBy,
  isEqual as _isEqual,
  isEmpty as _isEmpty,
  findIndex as _findIndex,
  isFunction as _isFunction,
} from 'lodash';
import PropTypes from 'prop-types';

import {
  VFText,
  Icon,
  QuickActionMenu,
  VFButton,
} from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import PlanAccordion from '../../../CommonUI/PlanAccordion';
import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './PlanSelection.Styles';

class PlanSelection extends Component {
  state = {
    activeIndexes: [],
    myPlanActiveIndex: [],
    plans: null,
    isInitialized: false,
    isOtherPlansChanged: false,
    isWhyThisPlanModalVisible: false,
  };

  static getDerivedStateFromProps(
    { plans, currentPlan, isEditMode, selectedPlan },
    { isInitialized, plans: sortedPlans },
  ) {
    const _plans = _sortBy(plans, 'isRecommended');
    let newState = {};
    //update active index on the first time only to get plans props
    if (!isInitialized && !_isEmpty(plans)) {
      const activeIndexes = _plans[0]?.isRecommended ? [0] : [];
      const myPlanActiveIndex = currentPlan?.isRecommended ? [0] : [];
      newState = {
        activeIndexes,
        myPlanActiveIndex,
        isInitialized: true,
      };
    }
    if (!_isEqual(_plans, sortedPlans)) {
      newState = {
        ...newState,
        plans: _plans,
      };
    }

    if (isEditMode && !isInitialized) {
      // if one of the other plans is selected
      const activeIndexes = [
        _findIndex(_plans, function (o) {
          return o.id == selectedPlan?.id;
        }),
      ];
      // if my current plane is selected
      const myPlanActiveIndex = currentPlan?.id === selectedPlan?.id ? [0] : [];
      newState = {
        ...newState,
        activeIndexes,
        myPlanActiveIndex,
        plans: _plans,
      };
    }
    return _isEmpty(newState) ? null : newState;
  }
  onStepLayout = ({ nativeEvent: { layout } }, step, index, isActive) => {
    const { isEditMode } = this.props;
    const { isOtherPlansChanged } = this.state;
    const isReadyToScroll = this.scrollViewRef && _isFunction(this.scrollViewRef.scrollTo);
    if (isActive && isEditMode && !isOtherPlansChanged && isReadyToScroll) {
      this.scrollViewRef.scrollTo({
        y: layout.y + 230,
        x: 0,
        animated: true,
        duration: 700,
      });
    }
  };

  onChangeMyPlan = indexes => {
    this.setState({
      myPlanActiveIndex: indexes,
    });
  };

  onChangeOtherPlans = indexes => {
    this.setState({
      activeIndexes: indexes,
      isOtherPlansChanged: true,
    });
  };

  planScrollViewRef = scrollViewRef => {
    this.scrollViewRef = scrollViewRef;
  };

  renderWhyThisPlanModal = isVisible => {
    const { whyThisPlanModelProps } = this.props;
    const { title, question, content, contentPlaceHolders, button, renderQAMContent, ...QAMProps } =
      whyThisPlanModelProps || {};
    return (
      <QuickActionMenu
        isVisible={isVisible}
        type="secondary"
        title={title}
        headerStyle={[styles.whyThisPlanModalHeader]}
        toggleModal={() => this.setState({ isWhyThisPlanModalVisible: false })}
        mainViewAccessibilityLabel={FrameworkTestKeys.PlanSectionQuickActionMainView}
        testID={FrameworkTestKeys.PlanSectionQuickActionMainView}
        {...QAMProps}
      >
        {_isFunction(renderQAMContent) ? (
          renderQAMContent()
        ) : (
          <View>
            <VFText type={'primary'} style={styles.whyThisPlanModalQuestion} i18nKey={question} />

            <VFText
              type={'primary'}
              style={styles.whyThisPlanModalContentText}
              i18nKey={content}
              placeHolders={contentPlaceHolders}
            />
            <VFButton
              onPress={() => this.setState({ isWhyThisPlanModalVisible: false })}
              style={styles.whyThisPlanModalButton}
              type="secondary"
              title={button || ''}
            />
          </View>
        )}
      </QuickActionMenu>
    );
  };
  render() {
    const {
      images,
      onSelectPlanPress,
      isLoading,
      theme,
      currentPlan,
      title,
      titleStyle,
      withButton,
      buttonTitle,
      buttonIcon,
      onButtonPress,
      buttonStyle,
      isCurrencyFirst,
      choosePlanButtonType,
      ...props
    } = this.props;
    const { plans, isWhyThisPlanModalVisible } = this.state;
    if (isLoading) {
      return null;
    }
    return (
      <ScrollView
        {...props}
        contentContainerStyle={styles.contentContainerStyle}
        style={styles.containerStyle}
        ref={this.planScrollViewRef}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.headerContainer}>
          <VFText i18nKey={title} style={[styles.choosePlanText, titleStyle]} />
          {withButton && (
            <TouchableOpacity onPress={onButtonPress} style={[styles.button, buttonStyle]}>
              <VFText style={styles.buttonText} i18nKey={buttonTitle} type="tertiary" />
              <Icon name={buttonIcon} type="image" size={22} style={styles.buttonIcon(theme)} />
            </TouchableOpacity>
          )}
        </View>

        <VFText
          i18nKey="device_upgrade_plan_screen_my_plan_title"
          style={styles.myCurrentPlanText(theme)}
        />

        <PlanAccordion
          onSelectPlanPress={onSelectPlanPress}
          activeSections={this.state.myPlanActiveIndex}
          sections={currentPlan ? [currentPlan] : []}
          images={images}
          onChange={this.onChangeMyPlan}
          onWhyThisPlanPress={() => {
            this.setState({ isWhyThisPlanModalVisible: true });
          }}
          recommendForYouKey={'device_upgrade_recommended_title'}
          freeSubscriptionsKey={'device_upgrade_plan_screen_plan_card_subscriptions_title'}
          whyThisPlanKey={'device_upgrade_plan_screen_plan_card_why_this_plan_title'}
          choosePlanKey={'device_upgrade_plan_step_cta_button_title'}
          isCurrencyFirst={isCurrencyFirst}
          choosePlanButtonType={choosePlanButtonType}
        />

        <VFText
          style={styles.myCurrentPlanText(theme)}
          i18nKey="device_upgrade_plan_screen_other_plans_title"
        />

        <PlanAccordion
          sectionContainerStyle={styles.sectionContainerStyle}
          onSelectPlanPress={onSelectPlanPress}
          activeSections={this.state.activeIndexes}
          sections={plans}
          images={images}
          onChange={this.onChangeOtherPlans}
          onSectionContainerLayout={this.onStepLayout}
          recommendForYouKey={'device_upgrade_recommended_title'}
          freeSubscriptionsKey={'device_upgrade_plan_screen_plan_card_subscriptions_title'}
          whyThisPlanKey={'device_upgrade_plan_screen_plan_card_why_this_plan_title'}
          choosePlanKey={'device_upgrade_plan_step_cta_button_title'}
          isCurrencyFirst={isCurrencyFirst}
        />

        {this.renderWhyThisPlanModal(isWhyThisPlanModalVisible)}
      </ScrollView>
    );
  }
}
PlanSelection.propTypes = {
  onSelectPlanPress: PropTypes.func,
  isLoading: PropTypes.bool,
  plans: PropTypes.array,
  currentPlan: PropTypes.object,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  title: PropTypes.string.isRequired,
  titleStyle: PropTypes.object,
  withButton: PropTypes.bool,
  buttonTitle: PropTypes.string,
  buttonIcon: PropTypes.string,
  onButtonPress: PropTypes.func,
  buttonStyle: PropTypes.object,
  isEditMode: PropTypes.bool,
  selectedPlan: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    price: PropTypes.number,
    currency: PropTypes.string,
    renderCustomPrice: PropTypes.func,
    isRecommended: PropTypes.bool,
    subscriptions: PropTypes.array,
    features: PropTypes.array,
  }),
  whyThisPlanModelProps: PropTypes.shape({
    title: PropTypes.string,
    question: PropTypes.string,
    content: PropTypes.string,
    contentPlaceHolders: PropTypes.array,
    button: PropTypes.string,
    renderQAMContent: PropTypes.func,
  }),
  isCurrencyFirst: PropTypes.bool,
  choosePlanButtonType: PropTypes.string,
  images: PropTypes.object,
};
PlanSelection.defaultProps = {
  theme: LightThemeColors,
};

export default withTheme(PlanSelection);
